import axios from 'axios';

export default class cmsApi {
  static getBanners(hostDomain) {
    const url = `${hostDomain || ''}/api/olympus/strapi/content-json/banners`;
    return axios.get(url).then(res => res.data);
  }
  static getVacancies() {
    const url = `/api/olympus/strapi/content-json/vacancies`;
    return axios.get(url).then(res => res.data);
  }
  static getDepartments() {
    const url = `/api/olympus/strapi/content-json/vacancies-helper`;
    return axios.get(url).then(res => res.data);
  }
}
